<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">银行到账</li>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="$judge_auth('127')"
        >添加</el-button
      >
      <el-button
        type="warning"
        :icon="Download"
        link
        @click="
          delete state.selectId;
          state.showImport = true;
        "
        v-if="$judge_auth('25')"
        >批量导入</el-button
      >
      <el-button
        type="primary"
        :icon="Upload"
        size="small"
        link
        @click="onExport"
        v-if="$judge_auth('26')"
        >导出
      </el-button>
    </ul>
    <ul class="c-list-search">
      <el-config-provider
        :value-on-clear="null"
        :empty-values="[undefined, null]"
      >
        <el-space wrap style="flex: 1">
          <el-input
            v-model="state.params.keywords"
            style="width: 200px"
            placeholder="付款账户、付款账号"
            clearable
            @clear="
              delete state.params.keywords;
              onLoad();
            "
            @paste.enter="$onKeywordsPaste($event, state.params)"
          ></el-input>
          <el-select
            v-model="state.bank_account_ids"
            style="width: 450px"
            placeholder="到账银行账户"
            multiple
            collapse-tags
            collapse-tags-tooltip
            @clear="
              state.indeterminate = false;
              state.checkAll = false;
              delete state.params.bank_account_ids;
            "
          >
            <template #header>
              <el-checkbox
                v-model="state.checkAll"
                :indeterminate="state.indeterminate"
                @change="onBankAccountCheckAll"
              >
                全选
              </el-checkbox>
            </template>
            <el-option
              v-for="item in state.bankaccount_data"
              :key="item"
              :label="`${item.name}(${item.account})`"
              :value="item.id"
            />
          </el-select>
          <el-select
            v-model="state.params.customer_id"
            placeholder="认领客户"
            style="width: 300px"
          >
            <el-option
              v-for="item in state.customer_data"
              :key="item"
              :value="item.id"
              :label="item.name"
            ></el-option>
            <template #footer>
              <el-button size="small" @click="onLoadCustomer()">
                刷新
              </el-button>
            </template>
          </el-select>
          <el-input-number
            v-model="state.params.received_amount"
            :min="0.01"
            :controls="false"
            class="number-input-left"
            :precision="2"
            placeholder="到款金额"
          />
          <el-select
            v-model="state.params.is_have_customer"
            style="width: 140px"
            placeholder="是否匹配客户"
          >
            <el-option label="未匹配客户" :value="0"></el-option>
            <el-option label="已匹配客户" :value="1"></el-option>
          </el-select>
          <el-select
            v-model="state.params.collected_status"
            style="width: 120px"
            placeholder="认领状态"
          >
            <el-option label="待认领" :value="0"></el-option>
            <el-option label="认领中" :value="1"></el-option>
            <el-option label="已认领" :value="2"></el-option>
          </el-select>
          <el-select
            v-model="state.params.freeze_status"
            style="width: 120px"
            placeholder="是否冻结"
          >
            <el-option label="未冻结" :value="0"></el-option>
            <el-option label="已冻结" :value="1"></el-option>
          </el-select>
          <el-date-picker
            v-model="state.dates"
            type="daterange"
            range-separator="至"
            start-placeholder="到账日期"
            end-placeholder="到账日期"
            value-format="YYYY-MM-DD"
            @change="
              (value) => {
                if (value)
                  state.params.received_date = value[0] + ' - ' + value[1];
              }
            "
            style="width: 260px"
            @clear="
              delete state.dates;
              delete state.params.received_date;
            "
          />
          <el-date-picker
            v-model="state.create_times"
            type="datetimerange"
            range-separator="至"
            start-placeholder="创建日期"
            end-placeholder="创建日期"
            value-format="YYYY-MM-DD"
            @change="
              (value) => {
                if (value)
                  state.params.create_time = value[0] + ' - ' + value[1];
              }
            "
            style="width: 380px"
            @clear="
              delete state.create_times;
              delete state.params.create_time;
            "
          />
          <el-tree-select
            v-model="state.params.customer_belonger_id"
            :props="{
              value: 'id',
              label: 'name',
              class: 'belonger-tree-class',
            }"
            node-key="id"
            value-key="id"
            placeholder="客服专员"
            :data="state.admin_data"
            default-expand-all
            filterable
            clearable
            style="width: 200px"
          />
          <el-dropdown split-button @click="onLoad" type="primary">
            查询
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                  重置
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-space>
      </el-config-provider>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <!-- <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        /> -->
        <el-table-column
          label="到款时间"
          prop="received_time"
          sortable="received_time"
          width="120"
          :formatter="$tab_TextFormat"
          fixed
        />
        <el-table-column
          label="付款人/付款银行"
          :formatter="
            (row) => $tab_GroupFormat(row.payment_name, row.payment_bank || '')
          "
          min-width="220"
        />
        <el-table-column
          label="金额"
          prop="received_amount"
          align="right"
          :formatter="$tab_PriceFormat"
          min-width="140"
        />
        <el-table-column
          label="实际到账金额/手续费"
          align="right"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                $priceFormat(row.real_received_amount),
                $priceFormat(row.service_fee),
              )
          "
          min-width="160"
        />
        <el-table-column
          label="已认领/未认领金额"
          min-width="160"
          align="right"
        >
          <template #default="{ row }">
            <div style="display: flex; justify-content: flex-end">
              <c_tabgroup
                :value1="$priceFormat(row.collected_amount)"
                style="
                  align-items: flex-end;
                  display: flex;
                  flex-direction: column;
                "
              >
                <template #bottom>
                  <c_money
                    style="font-weight: 600"
                    :value="row.uncollected_amount"
                  />
                </template>
              </c_tabgroup>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态/ID" sortable="id" width="120">
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <div style="display: flex; align-items: center">
                  <div
                    style="display: flex; align-items: center; column-gap: 5px"
                  >
                    <el-tag
                      type="warning"
                      size="small"
                      title="合并申请中"
                      style="cursor: pointer"
                      v-if="row.merge_status == 1"
                      >合
                    </el-tag>
                    <el-tag
                      type="success"
                      size="small"
                      title="已合并"
                      style="cursor: pointer"
                      v-else-if="row.merge_status == 2"
                      >合
                    </el-tag>
                    <el-tag
                      type="primary"
                      size="small"
                      title="该到款记录为合并后的到款记录"
                      style="cursor: pointer"
                      v-if="row.is_merge"
                      >合
                    </el-tag>
                    <c_status
                      arr-name="bankReceived_collected_status"
                      :value="row.collected_status"
                    />
                    <el-tooltip
                      v-if="row.is_have_check"
                      content="新申请待确认"
                      placement="right"
                    >
                      <el-icon
                        color="#ffa500"
                        style="margin-left: 5px; cursor: pointer"
                      >
                        <QuestionFilled />
                      </el-icon>
                    </el-tooltip>
                  </div>
                </div>
              </template>
              <template #bottom>
                <text
                  style="
                    color: #a2a2a2;
                    font-size: var(--tab-group-second-font-size);
                    text-align: center;
                  "
                >
                  {{ row.id }}
                </text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          label="匹配客户"
          prop="customer_name"
          width="200"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="到账银行"
          prop="bank_account.opening_bank"
          width="200"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="到账账户"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.bank_account?.account,
                row.bank_account?.name || '',
              )
          "
          min-width="220"
        />
        <el-table-column
          label="付款账户/开户行"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.payment_account,
                row.payment_opening_bank || '',
              )
          "
          min-width="220"
        />

        <el-table-column
          label="操作"
          width="260"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                $store.commit('openMenu', {
                  path: 'BankReceivedDetail',
                  title: '银行到账操作',
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
              v-if="$judge_auth('128')"
            >
              操作
            </el-button>
            <el-button
              type="primary"
              link
              icon="View"
              @click="
                $store.commit('openMenu', {
                  path: 'BankReceivedDetail',
                  title: '银行到账操作',
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
              v-else
            >
              查看
            </el-button>
            <el-button
              type="success"
              link
              icon="Connection"
              @click="
                state.selectItem = row;
                state.customer_id = row.customer_id;
                state.showCustomer = true;
              "
              v-if="$judge_auth('129')"
            >
              关联客户
            </el-button>
            <el-button
              type="danger"
              link
              icon="Delete"
              @click="onDelete(row.id)"
              v-if="$judge_auth('607')"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showInfo"
        :title="(state.selectId ? '修改' : '添加') + '到账公示'"
        @close="state.showInfo = false"
      >
        <c_BankReceivedInfo
          @close="
            state.showInfo = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_BankReceivedInfo>
      </c_popup>
    </transition>
    <el-dialog
      v-model="state.showImport"
      title="导入银行到账"
      width="40%"
      align-center
      :close-on-click-modal="false"
    >
      <c_BankReceivedImport
        v-if="state.showImport"
        @close="
          onLoad();
          state.showImport = false;
        "
      ></c_BankReceivedImport>
    </el-dialog>
    <el-dialog
      v-model="state.showCustomer"
      title="关联客户"
      width="500px"
      align-center
    >
      <ul>
        请选择要关联的客户
      </ul>
      <el-select
        v-model="state.customer_id"
        size="large"
        style="margin-top: 5px"
      >
        <el-option
          v-for="item in state.customer_data"
          :key="item"
          :value="item.id"
          :label="item.name"
        ></el-option>
        <template #footer>
          <el-button size="small" @click="onLoadBankAccount()">
            刷新
          </el-button>
        </template>
      </el-select>
      <ul style="text-align: right; margin-top: 40px">
        <el-button
          type="primary"
          @click="onSetCustomer"
          size="large"
          style="width: 100%"
        >
          提交
        </el-button>
      </ul>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive, watch } from "vue";
import {
  bankreceived_list,
  bankreceived_delete,
  bankreceived_editcustomer,
  bankreceived_export,
} from "@/http/bankreceived";
import { data_customer_select, data_bankaccount_select } from "@/http/data";
import { confirm_func } from "@/utils/qFormat";
import { ElMessageBox, ElMessage } from "element-plus";
import { admin_cascader } from "@/utils/qFormat";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadCustomer();
      onLoadBankAcount();
      onLoadAdmin();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      if (state.bank_account_ids?.length > 0)
        state.params.bank_account_id = state.bank_account_ids.join(",");

      bankreceived_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) {
          state.customer_data = res.data.data?.list;
        }
      });
    };

    const onLoadBankAcount = () => {
      data_bankaccount_select().then((res) => {
        if (res.status == 200) {
          state.bankaccount_data = res.data.data?.list;
        }
      });
    };

    //获取业务员
    const onLoadAdmin = () => {
      admin_cascader().then((res) => {
        state.admin_data = res;
      });
    };

    watch(
      () => state.bank_account_ids,
      (val) => {
        if (val?.length > 0) {
          if (val?.length === state.bankaccount_data?.length) {
            state.checkAll = true;
            state.indeterminate = false;
          } else {
            state.indeterminate = true;
          }
        } else {
          state.checkAll = false;
          state.indeterminate = false;
        }
      },
    );

    const onBankAccountCheckAll = (checked) => {
      // indeterminate.value = false;
      if (checked) {
        state.bank_account_ids = state.bankaccount_data.map((m) => m.id);
      } else {
        delete state.bank_account_ids;
      }
    };

    const onCustomerChange = (row) => {
      if (row.customer_old_id) {
        ElMessageBox.confirm(
          `您确定将该到款记录由原客户<strong style='color:#1e90ff'>${row.customer_old?.name}</strong>变更成客户<strong style='color:#f00'>${row.customer?.name}</strong>吗？`,
          "变更确认",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
            type: "warning",
          },
        )
          .then(() => {
            bankreceived_editcustomer({
              id: row.id,
              customer_id: row.customer?.id,
            }).then((res) => {
              if (res.status == 200) {
                ElMessage({
                  type: "success",
                  message: res.data.msg,
                });
                onLoad();
              }
            });
          })
          .catch(() => {
            row.customer_id = row.customer_old_id;
            row.customer = row.customer_old;
          });
      } else {
        ElMessageBox.confirm(
          `您确定将该到款记录绑定到客户<strong style='color:#f00'>${row.customer?.name}</strong>下吗？`,
          "绑定确认",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
            type: "warning",
          },
        )
          .then(() => {
            bankreceived_editcustomer({
              id: row.id,
              customer_id: row.customer?.id,
            }).then((res) => {
              if (res.status == 200) {
                ElMessage({
                  type: "success",
                  message: res.data.msg,
                });
                onLoad();
              }
            });
          })
          .catch(() => {
            row.customer_id = row.customer_old_id;
            row.customer = row.customer_old;
          });
      }
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.bank_account_ids;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //删除
    const onDelete = (id) => {
      confirm_func(bankreceived_delete, id, onLoad);
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      bankreceived_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    const onSetCustomer = () => {
      if (!state.selectItem) {
        return false;
      }

      if (!state.customer_id) {
        ElMessage.warning("请选择要关联的客户");
        return false;
      }

      const customer = state.customer_data.find(
        (w) => w.id == state.customer_id,
      );
      if (state.selectItem?.customer_id) {
        ElMessageBox.confirm(
          `您确定将该到款记录由原客户<strong style='color:#1e90ff'>${state.selectItem.customer_name}</strong>变更成客户<strong style='color:#f00'>${customer?.name}</strong>吗？`,
          "变更确认",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
            type: "warning",
          },
        ).then(() => {
          bankreceived_editcustomer({
            id: state.selectItem?.id,
            customer_id: customer?.id,
          }).then((res) => {
            if (res.status == 200) {
              ElMessage({
                type: "success",
                message: res.data.msg,
              });
              onLoad();
              state.showCustomer = false;
            }
          });
        });
      } else {
        ElMessageBox.confirm(
          `您确定将该到款记录绑定到客户<strong style='color:#f00'>${customer?.name}</strong>下吗？`,
          "绑定确认",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
            type: "warning",
          },
        ).then(() => {
          bankreceived_editcustomer({
            id: state.selectItem?.id,
            customer_id: customer?.id,
          }).then((res) => {
            if (res.status == 200) {
              ElMessage({
                type: "success",
                message: res.data.msg,
              });
              onLoad();
              state.showCustomer = false;
            }
          });
        });
      }
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
      onLoadCustomer,
      onCustomerChange,
      onExport,
      onSetCustomer,
      onBankAccountCheckAll,
    };
  },
};
</script>
<style lang="less">
.bank-received-index-tab-pop {
  .el-descriptions__header {
    margin-bottom: 0 !important;
  }
}
</style>
